export default __webpack_public_path__ + "static/media/2. Akt priema biomateriala obshchiy.15aeb438.pdf";